import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Instagram, Facebook, MapPin } from 'lucide-react';
import colors from '../theme/colors';
import { contactInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer style={{ backgroundColor: colors.primary, color: colors.background }} className="">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* About Section */}
          <div>
            <h3 className="text-2xl font-bold mb-4">HennabyAnjali</h3>
            <p className="opacity-90 leading-relaxed">
              Creating beautiful henna designs and stunning nail art with passion and precision. Your beauty is our artistry.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <div className="flex flex-col space-y-2">
              <Link to="/henna" className="opacity-90 hover:opacity-100 transition-opacity">Henna Services</Link>
              <Link to="/nail-art" className="opacity-90 hover:opacity-100 transition-opacity">Nail Art</Link>
              <Link to="/gallery" className="opacity-90 hover:opacity-100 transition-opacity">Gallery</Link>
              <Link to="/buy-henna-cone" className="opacity-90 hover:opacity-100 transition-opacity">Buy Henna Cones</Link>
              <Link to="/contact" className="opacity-90 hover:opacity-100 transition-opacity">Contact Us</Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Get in Touch</h4>
            <div className="flex flex-col space-y-3">
              <a href={`tel:${contactInfo.phone}`} className="flex items-center space-x-3 opacity-90 hover:opacity-100 transition-opacity">
                <Phone size={18} />
                <span>{contactInfo.phone}</span>
              </a>
              <a href={`mailto:${contactInfo.email}`} className="flex items-center space-x-3 opacity-90 hover:opacity-100 transition-opacity">
                <Mail size={18} />
                <span>{contactInfo.email}</span>
              </a>
              <div className="flex items-center space-x-4 mt-4">
                <a href={`https://instagram.com/${contactInfo.instagram.substring(1)}`} target="_blank" rel="noopener noreferrer" className="hover:opacity-70 transition-opacity">
                  <Instagram size={24} />
                </a>
                <a href={`https://facebook.com/${contactInfo.facebook}`} target="_blank" rel="noopener noreferrer" className="hover:opacity-70 transition-opacity">
                  <Facebook size={24} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div style={{ borderTopColor: 'rgba(255,255,255,0.2)' }} className="border-t mt-10 pt-8 text-center opacity-80">
          <p>&copy; {new Date().getFullYear()} HennabyAnjali. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;